export const config = {
    adminPortalApiUrl: "/api/admin-portal"
};